import { Injectable } from '@angular/core';
import { ItemService } from './item.service';
import { Deal } from '../models/deal.model';

@Injectable()
export class DealService implements ItemService {
  items: Deal[] = [];
}
